module.exports = __webpack_public_path__ + "static/img/avatar_user_male.2596f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/publicResource/common/img/avatar_user_male.png
// module id = bd4q
// module chunks = 10 11 12 13 25 37 41 94 97